import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject, first, config, isEmpty } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { JEService } from 'src/app/services/je-services.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Table } from 'primeng/table';
import { IpAddressService } from 'src/app/services/ip-address.service';
import saveAs from 'file-saver';
@Component({
  selector: 'app-tank-stage2',
  templateUrl: './tank-stage2.component.html',
  styleUrls: ['./tank-stage2.component.scss']
})
export class TankStage2Component implements OnInit {

  @ViewChild('tankTable', { static: true }) public tankDataTable: Table;

  num = 0;
  pondType = [
    { name: "Bricks Work" },
    { name: "Earth Work" },
  ];

  displayTankDialog2: boolean = false;
  wrongNotificationCheck2: boolean = true;
  submitEstimateFormStage2: FormGroup;
  submitFalseIntimateFormStage2: FormGroup;
  appID: any;
  items: any[];
  selectedStatus: any;
  selectedStatusFalseIntimation: any;
  //remarks: any;
  isSubmitted: boolean = false;
  isLoading = false;
  userId: any;
  stage: any;
  displayFileDialog: boolean;
  rotatableFilePath: any;
  pondList: any;
  public dialogData: any;
  public dialogData2: any;
  public tankData: any;
  // public pondData:any;
  stage2FalseIntimationremarks: any;
  stage2EstimateFormremarks: any;
  canEditPondData: boolean;
  actualSubsidy_Stage2: number;
  appId: number;
  pondSurveyStage2Data: any;
  longPosition: any;
  latPosition: any;
  PondVerDataStage2: any;
  // num: number;
  uploadOptions: any[];
  selectedCity1: any;
  //PondType:any;
  displayCameraComponent: boolean = false;
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();


  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: this.viewportToPixels('100vw') },
    height: { ideal: 500 },
  };
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  autoId: any;
  miPhysicalAppReqBody: any;
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  applicationNo: any;
  insertPondAttachments: any = [];
  displayCustom: boolean;
  activeIndex: number = 0;
  selectedRow: any;
  capturelist: Array<{ attachmentsDoc: any; documentType: any; }>;
  selectedPondType: any;
  Applicant_type: any;
  //selectedPondType: any;

  ipAddress: any = '000.000.000';
  XENdisplayCustom: boolean;
  XENactiveIndex: number = 0;
  selectedSurveyType: any
  xenLogin: any;
  jeLogin: any;
  appVerificationItems:MenuItem[];
  appVerificationModel:any[];

  public loading: boolean = false;
  public subscriptions: any = [];


  constructor(
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private messageService: MessageService,
    private pondService: JEService,
    private tokenService: TokenService,
    private deptDashBoardService: DepartmentDashboardService,
    private sanitizer: DomSanitizer,
    public router: Router,
    private route: ActivatedRoute,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
  ) { 
    const tokenData = sessionStorage.getItem('token') ? JSON.parse(sessionStorage.getItem('token')) : {}
    if(tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')){ 
      this.xenLogin = true
    }
    if(tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')){ 
      this.jeLogin = true
    }
  }

  ngOnDestroy(): void {
    this.displayCameraComponent = false;
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  //pondData: PondDataModel= new PondDataModel();
  ngOnInit(): void {
    this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];

    if (((this.router.url.startsWith('/je')) || this.router.url.startsWith('/sdo')) || (this.router.url.startsWith('/xen'))) {
      this.canEditPondData = false;
    }
    else {
      this.canEditPondData = true;
    }
    this.loadData();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'Tank_Stage_export');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'Tank_Stage_export'
          );
        },
      },
    ];
    this.getIP();
    this.getGPSCoordinates();
    this.submitEstimateFormStage2 = this._fb.group({
      topSizeLength: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      topSizeBreadth: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      bottomSizeLength: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      bottomSizeBreadth: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      depth: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      typeOfPond: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      toalCostOfWaterTank: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      totalAmountOfSubsidy: ['', Validators.required],
      AssistancePaidAtStage1: ['', Validators.required],
      amountOfTotalSubsidy: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      //estimateCopy: ['', Validators.required],
      // estimateCopy:[''], 
      latitude: [{ value: '', disabled: true }],
      longitude: [{ value: '', disabled: true }],
      measurementBookCopyPathStage2: [''],
      // remarks: ['', Validators.required],
    });
    this.submitFalseIntimateFormStage2 = this._fb.group({
      uploadThePhotoTaken: ['', Validators.required],
      //remarks: ['', Validators.required],
    });
    let actionId: number;
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
      // actionId = 30;
      actionId = 11;
    } else {
      actionId = 10; // Do not Change, it is fixed for Farmer Application Verifications
    }
    //let actionId = 10; // Do not Change, it is fixed for Farmer Application Verifications
    this.images = this.insertPondAttachments;
    //this.selectedPondType=this.pondType;

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });

    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
        }
      });

  }

  loadData() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    this.stage = 2;
    // this.loader.start();
    this.loading = true;
    let sub = this.pondService
      .getFarmerApplicationForPondVerStage2(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey', '', new Date(), 'Success');

          this.tankData = data;
          this.appVerificationModel=this.tankData;
          // this.loader.close();
          this.loading = false;
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey', '', new Date(), err);

          this.tankData = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  refreshTable() {
    this.loadData();
    this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appID,
          'Applicant Type': d.Applicant_type,
          'App type': d.FarmerName,
          'District': d.district,
          'block': d.block,
          "Village": d.village,
          'Total Area': d.Total_Area,
          'Age Of Application': d.AgeOfApplication,
          'Pending Completed Days': d.PendingCompletedDays,
          'Land Detail': d.LandDetail,
          'status': d.status,
          'Remarks': d.remarks,
          'Current Status': d.Status_Ar,
          
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'appID' },
      { field: 'Applicant_type', header: 'Applicant type' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'district', header: 'district' },
      { field: 'block', header: 'block' },
      { field: 'village', header: 'village' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'status', header: 'Status' },
      { field: 'remarks', header: 'Remarks' },
      { field: 'Status_Ar', header: 'Current Status' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }

  get tankFormControlsStage2() {
    return this.submitEstimateFormStage2.controls;
  }

  get falseIntimationFormControlsStage2() {
    return this.submitFalseIntimateFormStage2.controls;
  }


  onPondTypeSelected(event) {

    this.selectedPondType = event.value;
  }

  public prev = false;
  public XENprev = false;
  selectTankRowData(product) {
    this.selectedSurveyType = 1
    this.dialogData2 = [product];
    this.appID = product.appID;
    this.Applicant_type = product.Applicant_type;
    this.displayTankDialog2 = true;
    if (((this.router.url.startsWith('/je')) || this.router.url.startsWith('/sdo')) || (this.router.url.startsWith('/xen'))) {
      this.submitEstimateFormStage2.disabled ? this.submitEstimateFormStage2.enable() : this.submitEstimateFormStage2.enable();
      this.submitFalseIntimateFormStage2.disabled ? this.submitFalseIntimateFormStage2.enable() : this.submitFalseIntimateFormStage2.enable();
      this.canEditPondData = false;
    }

    this.appId = this.appID;
    this.loader.start();
    this.pondService
      .getPondVerDataByAppIdStage2(this.appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.PondVerDataStage2 = data;
          this.stage2EstimateFormremarks = data.Remarks;
          this.loader.close();
          if(this.PondVerDataStage2.SurveyType == 0) {
            this.selectedSurveyType = '0'
          } else {
            this.selectedSurveyType = 1
          }
          // if(this.PondVerDataStage2.Table.length>0)
          // {
            if(this.jeLogin) {
              for (let index = 0; index < this.PondVerDataStage2?.listImagePathJE?.length; index++) {
                this.PondVerDataStage2.listImagePathJE[index].attachmentRawUrl = this.PondVerDataStage2.listImagePathJE[index].ImagePath
                this.PondVerDataStage2.listImagePathJE[index].displayName = this.PondVerDataStage2.listImagePathJE[index].DocumentType
                this.PondVerDataStage2.listImagePathJE[index].attachment = this.PondVerDataStage2.listImagePathJE[index].ImagePath
              }
            this.insertPondAttachments = this.PondVerDataStage2?.listImagePathJE;
            }
            if(this.xenLogin) {
              for (let index = 0; index < this.PondVerDataStage2?.listImagePathXEN?.length; index++) {
                this.PondVerDataStage2.listImagePathXEN[index].attachmentRawUrl = this.PondVerDataStage2.listImagePathXEN[index].ImagePath
                this.PondVerDataStage2.listImagePathXEN[index].displayName = this.PondVerDataStage2.listImagePathXEN[index].DocumentType
                this.PondVerDataStage2.listImagePathXEN[index].attachment = this.PondVerDataStage2.listImagePathXEN[index].ImagePath
  
                }
              this.insertPondAttachments = this.PondVerDataStage2?.listImagePathXEN;
              }
          sessionStorage.setItem('pondData', JSON.stringify(data));
          this.prev = Array.isArray(this.PondVerDataStage2?.listImagePathJE) && this.PondVerDataStage2?.listImagePathJE.length > 0;
          this.XENprev =
          Array.isArray(this.PondVerDataStage2?.listImagePathXEN) &&
          this.PondVerDataStage2?.listImagePathXEN.length > 0;
          this.populateAndCalculateData(data);


          // }
        },
        // error: () => {
        //   this.messageService.add({
        //     severity: 'error',
        //     summary: 'Error Message',
        //     detail: 'Data error! Dashboard not loaded.',
        //   });
        // },
      });

    // if(product.Stage==2)
    //   {
    // this.dialogData2 = [product];
    // this.appID = product.appID;
    // this.displayTankDialog2 = true;
    // }
    // else{
    //   console.log("error");
    // }
    this.loader.close();
  }


  onCloseDialog() {
    this.submitEstimateFormStage2.reset();
    this.displayTankDialog2 = false;
    this.isSubmitted = false;
    this.insertPondAttachments = [];
    // if(this.isSubmitted==true)
    // {
    //   this.submitEstimateFormStage2.reset();
    //   this.displayTankDialog2 = false;
    // }
    this.stage2EstimateFormremarks=''
  }

  onUpload(event, formcontrol, uploadElement, step) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    if (step == 1) {
      let phNo = sessionStorage.getItem('farmerPh');
      this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
        if(resp.data){
          this.tankFormControlsStage2.measurementBookCopyPathStage2.setValue(resp.data);
        }
        if (resp.statusCode == 200) {
          this.submitEstimateFormStage2.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
      uploadElement.clear();
    }
    else {
      let phNo = sessionStorage.getItem('farmerPh');
      this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          this.submitFalseIntimateFormStage2.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
      uploadElement.clear();
    }
  }


  PostFalseIntimate(reqBody1) {
    this.loader.start();
    this.pondService
      .PondFalseIntimation(reqBody1)
      .pipe()
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 False Intimation Action', reqBody1?.appID, new Date(), data.toString(), reqBody1);

          this.loader.close();
          // console.log('POST VENDOR POND FALSE INTIMATION SUCCESS', data);
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: 'Pond false Intimation Added Successfully',
          });
        },
        error: (err) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 False Intimation Action', reqBody1?.appID, new Date(), err, reqBody1);

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error!  false Intimation Not Added',
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Pond false Intimation Added Successfully',
        //   });
        // },
      });
  }



  submitFalseIntimateStage2() {
    if(this.submitFalseIntimateFormStage2.get('uploadThePhotoTaken').value == ''){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Please Upload Photo',
      });
      return;
    }

    this.isSubmitted = true;
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let userId = JSON.parse(payload)?.sub;
    let reqBody1: any = {
      appID: this.appID,
      stage: "2",
      status: this.selectedStatusFalseIntimation.flag,
      terminalID: this.ipAddress,
      networkID: this.ipAddress,
      //remarks: this.submitFalseIntimateFormStage2.get('remarks').value,
      photoPath: this.submitFalseIntimateFormStage2.get('uploadThePhotoTaken').value,
      userID: this.userId,
      remarks: this.stage2FalseIntimationremarks ? this.stage2FalseIntimationremarks : '',
    };
    this.PostFalseIntimate(reqBody1)
    //this.onCloseDialog();
  }

  submitEstimateStage2() {
    this.isSubmitted = true;
    // console.log('Image List', this.images);
    // console.log('Document List', this.insertPondAttachments);
    let isValid = true;
    if (this.router.url.startsWith('/je') || (this.xenLogin && this.selectedSurveyType == 1)) {
      if (!this.insertPondAttachments || this.insertPondAttachments.length == 0) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Images are Mandatory' });
        return;
      }
      // this.capturelist = [{
      //   "attachmentsDoc": this.insertPondAttachments[0].attachment,
      //   "documentType": this.insertPondAttachments[0].displayName,
      // }]
    }
    if (!this.stage2EstimateFormremarks) {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Remarks are required' });
      return;
    }
    // let body = [];
    // this.insertPondAttachments.forEach(document => {
    //   body.push({
    //     "attachmentsDoc": document?.attachment,
    //     "documentType": document?.displayName,
    //   })
    // })          
    //   console.log("body",body);

    //   this.insertPondAttachments=body;
  
    if (this.submitEstimateFormStage2.valid) {
      this.capturelist = []
      if(this.insertPondAttachments && this.insertPondAttachments.length > 0) {
      for (let index = 0; index < this.insertPondAttachments.length; index++) {
       let obj =  {
          attachmentsDoc: this.insertPondAttachments[index].attachment,
          documentType: this.insertPondAttachments[index].displayName,
        }
        this.capturelist.push(obj)
      }
    }
      this.isLoading = true;
      let sessionToken = sessionStorage.getItem('token');
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      let userId = JSON.parse(payload)?.sub;
      let reqBody: any = {
        appID: this.appID,
        stageType: 2,
        userID: userId,
        totalAmtStage2: this.num.toString(),
        // stateShare_Amount:this.actualSubsidy_Stage2 *0.40,
        // centerShare_Amount:this.actualSubsidy_Stage2 *0.60,
        stateShare_Amount: 0,
        centerShare_Amount: 0,
        networkId: this.ipAddress,
        terminalId: this.ipAddress,
        //actualSubsidy_Stage2:0,
        assistancePaidAtStage2: this.num.toString(),
        status: this.selectedStatus.flag,
        topLength: this.submitEstimateFormStage2.get('topSizeLength').value,
        topBreadth: this.submitEstimateFormStage2.get('topSizeBreadth').value,
        topSize: `${this.submitEstimateFormStage2.get('topSizeLength').value *
          this.submitEstimateFormStage2.get('topSizeBreadth').value
          }`,
        bottomLength: this.submitEstimateFormStage2.get('bottomSizeLength').value,
        bottomBreadth: this.submitEstimateFormStage2.get('bottomSizeBreadth').value,
        bottomSize: `${this.submitEstimateFormStage2.get('bottomSizeLength').value *
          this.submitEstimateFormStage2.get('bottomSizeBreadth').value
          }`,
        depth: this.submitEstimateFormStage2.get('depth').value,
        typeOfPond: this.submitEstimateFormStage2.get('typeOfPond').value,
        tankLat: this.submitEstimateFormStage2.get('latitude').value,
        tankLng: this.submitEstimateFormStage2.get('longitude').value,
        totalEstimatedCost: this.submitEstimateFormStage2.get('toalCostOfWaterTank').value,
        totalEstimatedSubsidy: this.submitEstimateFormStage2.get('totalAmountOfSubsidy').value,
        actualSubsidy_Stage2: this.submitEstimateFormStage2.get('amountOfTotalSubsidy').value,
        measurementCopy: this.submitEstimateFormStage2.get('measurementBookCopyPathStage2')
          .value,
        // remarks: this.submitEstimateFormStage2.get('remarks').value,
        remarks: this.stage2EstimateFormremarks,
        insertPondAttachments: this.capturelist,
        surveyType: this.selectedSurveyType,
      };
      // console.log(reqBody, 'reqBody')
      this.postVendorPondEstimate(reqBody);
      //this.onCloseDialog();
    }
  }

  wrongNotification2(submitEstimateFormStage2) {
    this.wrongNotificationCheck2 = !this.wrongNotificationCheck2;

    if(!this.wrongNotificationCheck2){
      this.selectedStatusFalseIntimation = this.items[1];
    }

    submitEstimateFormStage2 = false;
  }

  @ViewChild('myname') myname: ElementRef;
  rotationAmount = 0;
  scalingAmount = 1;
  transformImage(direction, scale) {
    if (direction) {
      this.rotationAmount += direction == 'left' ? -90 : 90;
    }
    if (scale) {
      this.scalingAmount += scale == 'zoom-out' ? -0.1 : 0.1;
    }
    this.myname.nativeElement.style.transform = `rotate(${this.rotationAmount}deg) scale(${this.scalingAmount})`;
  }
  openFileDialog(filePath) {
    this.rotatableFilePath = filePath;
    this.displayFileDialog = true;
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.rotatableFilePath)
  }
  onCloseFileDialog() {
    this.displayFileDialog = false;
  }

  numberEquals(num1, num2) {
    return Number(num1) == Number(num2);
  }
  postVendorPondEstimate(reqBody) {
    this.loader.start();
    this.pondService
      //.vendorPondEstimate(reqBody)
      .pondSurveyStage2(reqBody)
      .pipe()
      .subscribe({
        next: (data: any) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 False Intimation Action', reqBody?.appID, new Date(), data.toString(), reqBody);
          this.loader.close();
          //this.pondData=data;
          this.pondSurveyStage2Data = data;
          if(data == "S:Successfully Submitted"){
            
          // this.loadData();
          let index=this.tankData.findIndex(e=>{return e.appID==reqBody.appID})
          let index1=this.tankDataTable.filteredValue.findIndex(e=>{return e.appID==reqBody.appID})
            this.tankData.splice(index,1)
            this.tankDataTable.filteredValue.splice(index1,1)
            // this.loadData();
          this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data.toString(),
            });
            
          }
          else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data.toString(),
            });
          }
          this.displayTankDialog2 = false;
          
        },
        error: (err) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 False Intimation Action', reqBody?.appID, new Date(), err, reqBody);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  populateAndCalculateData(data) {
    this.tankFormControlsStage2.topSizeLength.setValue(data?.topLength);
    this.tankFormControlsStage2.topSizeBreadth.setValue(data?.topBreadth);
    this.tankFormControlsStage2.latitude.setValue(this.latPosition);
    this.tankFormControlsStage2.longitude.setValue(this.longPosition);
    this.tankFormControlsStage2.toalCostOfWaterTank.setValue(data?.TotalEstimatedCost);
    this.tankFormControlsStage2.depth.setValue(data?.depth);
    // this.onPondTypeSelected({ value: this.selectedPondType });
    this.tankFormControlsStage2.typeOfPond.setValue(data?.TypeOfPond);
    // this.tankFormControlsStage2.typeOfPond.setValue(data?.TypeOfPond);
    this.tankFormControlsStage2.totalAmountOfSubsidy.setValue(data?.TotalEstimatedSubsidy);
    this.tankFormControlsStage2.measurementBookCopyPathStage2.setValue(data?.estimateCopy_Stage1);
    this.tankFormControlsStage2.bottomSizeLength.setValue(data?.bottomLength);
    this.tankFormControlsStage2.bottomSizeBreadth.setValue(data?.bottomBreadth);
    this.tankFormControlsStage2.amountOfTotalSubsidy.setValue(data?.ActualSubsidy_Stage2);
    this.tankFormControlsStage2.AssistancePaidAtStage1.setValue(data?.AssistancePaidAtStage1);
  }

  get hasPrevAttachments() {
    return Array.isArray(this.PondVerDataStage2?.listImagePath) && this.PondVerDataStage2?.listImagePath[0].length > 0
  }
  pondSurveyStage2(reqBody) {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let body = [];
    let element =
    {
      "ActualSubsidy_Stage1": this.PondVerDataStage2?.ActualSubsidy_Stage1,
      "appID": this.PondVerDataStage2?.App_ID,
      "centerShare_Amount": this.PondVerDataStage2?.CenterShare_Amount,
      "remarks": this.PondVerDataStage2?.Remarks,
      "stateShare_Amount": this.PondVerDataStage2?.StateShare_Amount,
      "volumeEarthWork": this.PondVerDataStage2?.VolumeEarthWork,
      "bottomBreadth": this.PondVerDataStage2?.bottomBreadth,
      "bottomLength": this.PondVerDataStage2?.bottomLength,
      "bottomSize": this.PondVerDataStage2?.bottomSize,
      "typeOfPond": this.PondVerDataStage2?.TypeOfPond,
      "depth": this.PondVerDataStage2?.depth,
      "measurementCopy": this.PondVerDataStage2?.MeasurementCopy,
      "totalEstimatedCost": this.PondVerDataStage2?.TotalEstimatedCost,
      "topBreadth": this.PondVerDataStage2?.topBreadth,
      "topLength": this.PondVerDataStage2?.topLength,
      "topSize": this.PondVerDataStage2?.topSize,
      // "totalBilledAmount": parseFloat(this.PondVerDataStage2?.TotalBilledAmount),
      "tankLat": this.PondVerDataStage2?.tankLat ? this.PondVerDataStage2?.tankLat : this.latPosition,
      "tankLng": this.PondVerDataStage2?.tankLng ? this.PondVerDataStage2?.tankLng : this.longPosition,
      "actualSubsidy_Stage2": this.PondVerDataStage2?.ActualSubsidy_Stage2,
      "insertPondAttachments": this.PondVerDataStage2?.listImagePath,


      //"ActualSubsidy_Stage1": this.PondVerDataStage2?.ActualSubsidy_Stage1,
      //  "appID": this.PondVerDataStage2?.App_ID,
      //  "CenterShare_Amount": this.PondVerDataStage2?.CenterShare_Amount,
      //  "Remarks": this.PondVerDataStage2?.Remarks,
      //  "StateShare_Amount": this.PondVerDataStage2?.StateShare_Amount,
      //  "VolumeEarthWork": this.PondVerDataStage2?.VolumeEarthWork,
      //  "bottomBreadth": this.PondVerDataStage2?.bottomBreadth,
      //  "bottomLength": this.PondVerDataStage2?.bottomLength,
      //  "bottomSize": this.PondVerDataStage2?.bottomSize,
      //  "depth": this.PondVerDataStage2?.depth,
      //  "measurementCopy": this.PondVerDataStage2?.estimateCopy,
      //  "totalEstimatedCost": this.PondVerDataStage2?.estimateCost,
      //  "topBreadth": this.PondVerDataStage2?.topBreadth,
      //  "topLength": this.PondVerDataStage2?.topLength,
      //  "topSize": this.PondVerDataStage2?.topSize,
      //  "tankLat": this.PondVerDataStage2?.tankLat ? this.PondVerDataStage2?.tankLat : this.latPosition,
      //  "tankLng": this.PondVerDataStage2?.tankLng ? this.PondVerDataStage2?.tankLng : this.longPosition,


    }
    body.push(element);
    sessionStorage.setItem('pondReqBody', JSON.stringify(body));
  }

   getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
    });
  }

  _getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  images = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }

  openCamera() {
    this.displayCameraComponent = true;
  }

  onCloseCameraDialog() {
    this.displayCameraComponent = false;
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }


  public handleImage(webcamImage: WebcamImage): void {
    // console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    this.imageCaptured = true;
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    // console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    if(!this.insertPondAttachments) {
      this.insertPondAttachments = []
    }
    const arr = this.webcamImage.imageAsDataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], "camera-captured" + '.jpeg', { type: mime })
    let data = new FormData();
    data.append('file', file);
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = JSON.parse(payload)?.sub;
    this.route.queryParams
      .subscribe(params => {
        this._personalDetalSer
          .uploadFile(data, phNo, "camera-captured")
          .subscribe((resp: any) => {
            if (resp.statusCode == 200) {
              const fileName = `tankPhotoStage1_${new Date().getTime()}`;
              this.insertPondAttachments.push({
                attachment: resp.data,
                attachmentRawUrl: this.webcamImage.imageAsDataUrl,
                displayName: fileName,
              });

              let documentListObject = {
                'insertPondAttachments': this.insertPondAttachments
              }
              this.displayCameraComponent = false;
              this.imageCaptured = false;

            } else {
              // console.log('Error');
            }
          });
      }
      );
  }

  retake() {
    this.imageCaptured = false;
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  selectFarmerApplication(application) {
    if(application.appID){
      // this.dashboard
      // .getMIDetailByAppID(application.appID)
      // .pipe(first())
      // .subscribe({
      //   next: (res) => {
      //     const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', application.appID, ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
      //     window.open(link, '_blank');
      //   },
      //   error: (err) => {
      //     console.log("error", err);
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error Message',
      //       detail: err,
      //     });
      //   },
      // });
      const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', application.appID]));
      window.open(link, '_blank');
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.PendingCompletedDays <= -2) {
        return '#ff8080';
      } else if (row.PendingCompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.PendingCompletedDays >= -1) {
        return '#99e699';
      } else if (row.PendingCompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  removeCaptureImg(index){
    this.insertPondAttachments.splice(index, 1)
  }
  XENimageClick(index: number) {
    this.XENactiveIndex = index;
    this.XENdisplayCustom = true;
  }
  getSurveyType(event){
    this.selectedSurveyType = event
  }
  isEmpty(data:any) {
    if(data == null || data == undefined || data == ''){
      return true
    }
  }
}
